import { createContext } from "react";
import type { ConfirmDialogOptions } from "../components/ConfirmDialog";

type ConfirmDialogContextType = {
  openDialog: (options: ConfirmDialogOptions) => void;
};

export const ConfirmDialogContext = createContext<ConfirmDialogContextType | undefined>(undefined);
